export function filterPropsMap(arr, fields) {
    return arr.map(el => fields.reduce((a, c) => ({ ...a, [c]: el[c] }), {}));
}
